import { useEffect, useState } from "react";

import Style from "./ClickSignDetailsStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import PageTitle from "../../../components/PageTitle";
import ReturnButton from "../../../components/Buttons/ReturnButton";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import { AxiosRequestConfig } from "axios";
import api from "../../../services/api";

export default function ClickSignDetails(props: any) {
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [url, setUrl] = useState("");
  const [clicksignToken, setClicksignToken] = useState("");
  const [adminName, setAdminName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [integrationId, setIntegrationId] = useState(0);

  const [errorMessage, setErrorMessage] = useState("");

  const enterpriseId = props.match.params.enterpriseId;

  const creatingNew = integrationId <= 0;

  useEffect(() => {
    LoadIntegration();

  }, []);

  async function LoadIntegration() {
    try {
      setLoading(true)
      const result = await api.get(`/clicksign/integrations/${enterpriseId}`);
      if (result.data.success) {
        const integration = result.data.integration;
        console.log("integration: ", integration);
        if (!integration)
          return;

        setUrl(integration.url);
        setClicksignToken(integration.token);
        setAdminName(integration.adminName);
        setAdminEmail(integration.adminEmail);
        setIntegrationId(integration.id);
      }
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Não foi possível carregar produto");
    }
    finally {
      setLoading(false);
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopUp() {
    setShowPopup(false);
  }

  async function OnSubmit() {
    try {
      if (!adminName.includes(" ")) {
        setErrorMessage("Nome inválido, deve ser completo");
        return;
      }

      setLoading(true);
      onClosePopUp();

      const options: AxiosRequestConfig = {};

      const data = { url, clicksignToken, adminName, adminEmail };

      const integrationUrl = `/clicksign/integrations/${enterpriseId}`;
      await (creatingNew ? api.post(integrationUrl, data, options) : api.put(integrationUrl, data, options));

      props.history.goBack();
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
      onClosePopUp();
    }
  }

  return (
    <Style className="default-page">
      <PageTitle title="Integração ClickSign" />

      <ReturnButton history={props.history} />

      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopUp}
        loading={loading}
        title={creatingNew ? "Cadastro de integração" : "Edição de integração"}
        body={"Você tem certeza que deseja " + (creatingNew ? "cadastrar esta integração?" : "editar esta integração?")}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopUp}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={OnSubmit}
        primaryDisabled={loading}
      />

      <Spinner spinning={loading} />
      {errorMessage && <p className="alert alert-danger">Erro: {errorMessage}</p>}

      <main className="default-main">
        <div className="panel">
          <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
            <h2>{creatingNew ? "Criação" : "Edição"} de empreendimento</h2>
            <div>
              <label>Url:</label>
              <input
                disabled={loading}
                defaultValue={url}
                onChange={e => setUrl(e.target.value)}
              />
            </div>

            <div>
              <label>Token:</label>
              <input
                disabled={loading}
                defaultValue={clicksignToken}
                onChange={e => setClicksignToken(e.target.value)}
              />
            </div>

            <div>
              <label>Nome Admin:</label>
              <input
                disabled={loading}
                defaultValue={adminName}
                onChange={e => setAdminName(e.target.value)}
              />
            </div>

            <div>
              <label>Email Admin:</label>
              <input
                disabled={loading}
                defaultValue={adminEmail}
                onChange={e => setAdminEmail(e.target.value)}
              />
            </div>



            <button
              className="btn btn-success btn-lg mt-4"
              type="button"
              disabled={loading}
              onClick={e => {
                e.preventDefault();
                onOpenPopUp();
              }}>{creatingNew ? "Cadastrar" : "Editar"}</button>
          </form>
        </div>
      </main>
    </Style>
  );
}